<template>
    <div class="main-form">
        <StepNumber
            stepNum="3"
            totalSteps="5"
        ></StepNumber>
        <div class="main-form_info">
            <InputSlider
                :minValue = 0
                :maxValue = 1000000
                :step = 1000
                :currentValue = "$store.state.prescoringData.precio_compra??0"
                :title = "$store.state.newTexts.step_datos_hipoteca_mejora[0].title"
                @valueChanged = "(value) => handleValueChanged('precio_compra',value)"
            ></InputSlider>        
            <InputSelect
                :options = "$store.state.inputOptionsVariables.provincias"
                placeholder = "Selecciona provincia"
                :title = "$store.state.newTexts.step_datos_hipoteca_mejora[1].title"
                :explanation = "$store.state.newTexts.step_datos_hipoteca_mejora[1].explanation || ''"
                :selected = "$store.state.prescoringData.provincia"
                @valueChanged = "(value) => handleValueChanged('provincia',value)"
            ></InputSelect>
            <InputSlider
                :minValue = 0
                :maxValue = 1000000
                :step = 1000
                :currentValue = "$store.state.prescoringData.capital_pendiente??0"
                :title = "$store.state.newTexts.step_datos_hipoteca_mejora[2].title"
                @valueChanged = "(value) => handleValueChanged('capital_pendiente',value)"
            ></InputSlider>
            <!-- Interés -->
            <div>
                <TitleAndExplanation 
                    :title = "$store.state.newTexts.step_datos_hipoteca_mejora[3].title"
                ></TitleAndExplanation>
                <div class="tipo-interes-wrapper">
                    <div class="radio-buttons">
                        <InputRadioButtons 
                            :options = "$store.state.inputOptionsVariables.tipo_hipoteca"
                            :selected = "$store.state.prescoringData.tipo_hipoteca_actual"
                            @valueChanged = "(value) => handleValueChanged('tipo_hipoteca_actual',value)"
                        ></InputRadioButtons>
                    </div>
                    <div class="input-text percentage-wrapper">
                        <InputField 
                            inputType = "number" 
                            placeholder = "Interés"
                            label = "Interés"
                            :isRequired = "true"
                            :currentValue = $store.state.prescoringData.tin_hipoteca_actual
                            @valueChanged = "(value) => handleValueChanged('tin_hipoteca_actual',value)" />
                    </div>
                </div>
            </div>
            <!-- Tiempo -->
            <div>
                <TitleAndExplanation 
                    :title = "$store.state.newTexts.step_datos_hipoteca_mejora[4].title"
                ></TitleAndExplanation>
                <div class="tipo-tiempo-wrapper">
                    <div class="input-text">
                        <InputField 
                            inputType = "number" 
                            placeholder = "Años"
                            label = "Años"
                            :currentValue = "$store.state.prescoringData.anyos_hipoteca_actual"
                            @valueChanged = "(value) => handleValueChanged('anyos_hipoteca_actual',value)" />
                    </div>
                    <div class="input-text">
                        <InputField 
                            inputType = "number" 
                            placeholder = "Meses"
                            label = "Meses"
                            :currentValue = "$store.state.prescoringData.meses_hipoteca_actual"
                            @valueChanged = "(value) => handleValueChanged('meses_hipoteca_actual',value)" />
                    </div>
                </div>
            </div>
        </div>
        <NavegationButtons 
            :nextStep = "nextStep"
            :nextStepButtonActive = "canContinue"
            nextStepButtonText = "Continuar"
            backStepButtonText = "Atrás"
        ></NavegationButtons>
    </div>
</template>

<script>
import StepNumber from '../common/StepNumber.vue'
import NavegationButtons from '../common/NavegationButtons.vue'
import InputSlider from '../common/InputSlider.vue'
import InputField from '../common/InputField.vue'
import InputSelect from '../common/InputSelect.vue'
import InputRadioButtons from '../common/InputRadioButtons.vue'
import TitleAndExplanation from '../common/TitleAndExplanation.vue'

export default {
    name: 'DatosHipotecaHabitual',
    components: {
        StepNumber,
        NavegationButtons,
        InputSlider,
        InputField,
        InputSelect,
        InputRadioButtons,
        TitleAndExplanation
    },
    computed: {
        nextStep(){
            return 'step_datos_titular';
        },
        canContinue(){
            const { precio_compra, provincia, capital_pendiente, tipo_hipoteca_actual, tin_hipoteca_actual, anyos_hipoteca_actual, meses_hipoteca_actual } = this.$store.state.prescoringData;
            return precio_compra !== null && precio_compra > 0 
                    && provincia !== null && provincia !== '' 
                    && capital_pendiente !== null && capital_pendiente > 0
                    && tipo_hipoteca_actual !== null && tipo_hipoteca_actual !== ''
                    && tin_hipoteca_actual !== null && tin_hipoteca_actual > 0
                    && ((anyos_hipoteca_actual !== null && anyos_hipoteca_actual > 0) || (meses_hipoteca_actual !== null && meses_hipoteca_actual > 0));
        }
    },
    methods: {
        handleValueChanged(field, value){
            this.$store.commit('updatePrescoringData', { field, value });
        }
    }
}
</script>

<style>
    .tipo-interes-wrapper{
        margin-top: 24px;
        display: flex;
        gap: 25px;
        align-items: center;
        justify-content: space-between;
    }
    .tipo-interes-wrapper .radio-buttons{
        flex: 2;
    }
    .tipo-interes-wrapper .radio-buttons .form-options{
        margin-top: 0;
        flex-direction: row;
        justify-content: space-between;
        gap: 10px;
        width: 100%;
        flex-wrap: nowrap;
    }
    .tipo-interes-wrapper .radio-buttons .form-options .radio-button_container{
        width: 100%;
    }
    .tipo-interes-wrapper .input-text{
        flex: 1;
        position: relative;
    }
    .percentage-wrapper input {
        padding-right: 2.5rem; 
    }
    .percentage-wrapper::after {
        content: '%';
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        font-weight: var( --font-weight-bold);
        color: var( --primary);
    }
    .tipo-tiempo-wrapper{
        margin-top: 24px;
        display: flex;
        gap: 25px;
        align-items: center;
        justify-content: space-between;
    }
    .tipo-tiempo-wrapper .input-text{
        flex: 1;
    }

    /* MOVIL */
    @media (max-width: 768px) {
        .tipo-interes-wrapper  {
            display: flex;
            flex-direction: column; 
        }
        .tipo-interes-wrapper .radio-buttons .form-options{
            display: flex;
            flex-direction: column;    
        }
        .tipo-interes-wrapper .radio-buttons {
            width: 100%;
        }
        .tipo-interes-wrapper .input-text{
            width: 100%;
        }
        .tipo-tiempo-wrapper{
            display: flex;
            flex-direction: column; 
        }
        .tipo-tiempo-wrapper .input-text{
            width: 100%;
        }

    }

</style>
